import { CommonModule } from '@angular/common';
import { Component, Input, signal, computed } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAbstractFilterChip, GalaxyFilterValueInterface } from '@vendasta/galaxy/filter/chips';

@Component({
  template: ``,
  imports: [CommonModule, TranslateModule],
})
export abstract class AbstractAssigneeFilterChipComponent<T> implements GalaxyAbstractFilterChip {
  selectedAssigneeIds = signal<string[]>([]);
  selectedAssignees = signal<T[]>([]);
  @Input() set initialValue(value: GalaxyFilterValueInterface[]) {
    this.selectedAssigneeIds.set(value?.map((v) => v.string ?? '').filter(Boolean) || []);
  }

  selectedAssigneesText = computed(() => {
    if (this.selectedAssignees().length === 0) {
      return '';
    }
    const firstAssigneeName = this.getDisplayName(this.selectedAssignees()[0]) || this.selectedAssigneeIds()[0];
    if (this.selectedAssignees().length === 1) {
      return firstAssigneeName;
    }
    return `${firstAssigneeName} +${this.selectedAssignees().length - 1}`;
  });

  abstract getDisplayName(assignee: T): string;
}
